// extracted by mini-css-extract-plugin
export default {"tickerShell":"Ticker_tickerShell__UUNUp","timeIsUp":"Ticker_timeIsUp__ytLvV"};